import React, { useContext } from 'react'

import CriterionC from './components/criterionC/criterionC'
import EcosystemData from './components/EcosystemData/EcoSystemList'
import { SiteContext } from 'providers/site'
import SpeciesDetails from './components/SpeciesDetails'
import CriterionE from './components/criterionE/criterionE'
import ScrollToTop from 'components/ScrollToTop'
import CongregationsList from './components/CongregationsSection/CongregationsList'
import { ProfileContext } from 'providers/profile'
import { canViewSensitive } from 'utils/rolePermissions'
import { useIBAAccess } from 'hooks/useIBAAccess'
import { SITE_STATUS_NOMINATED_ID, SITE_STATUS_PROPOSED_ID, SITE_STATUS_REVIEWED_BY_RFP_ID } from 'constants/siteStatuses'

const SiteProposalAssessmentPage = () => {
  const { profile } = useContext(ProfileContext)
  const { site, setSiteProposalFieldValidation } = useContext(SiteContext)

  // Check if user has IBA access for congregations for this site
  const { canSeeSiteIBACongregations } = useIBAAccess()
  
  // Show congregations if user has IBA access for this site and site status allows it
  // eslint-disable-next-line no-magic-numbers
  const showCongregations = canSeeSiteIBACongregations(site) || (site.SiteStatusId === SITE_STATUS_PROPOSED_ID || site.SiteStatusId === SITE_STATUS_NOMINATED_ID || site.SiteStatusId === SITE_STATUS_REVIEWED_BY_RFP_ID || canViewSensitive(profile.RoleId))

  if (!site.id) {
    return null
  }

  return (
    <div>
      <SpeciesDetails site={site} />
      {showCongregations && (
        <CongregationsList site={site} setSiteProposalFieldValidation={setSiteProposalFieldValidation} />
      )}
      <EcosystemData site={site} />
      <CriterionC site={site} />
      <CriterionE site={site} /> 
      <ScrollToTop bottom='104px' />
    </div>
  )
}

export default SiteProposalAssessmentPage
